<p-dialog [(visible)]="displayDialog" [modal]="true" [style]="{width: '700px'}" (onHide)="cancel()">
    <ng-template pTemplate="header">
        <div class="w-full text-center font-22 font-weight-600" translate>savings.interest_payment</div>
    </ng-template>

    <div class="">
        <form #form="ngForm" (ngSubmit)="onSave()">
            <div class="">
                <div class="m-auto col-11">
                    <div class="row form-input-row">
                        <div class="col-5 text-right"><span translate>orders.document_number</span><span class="requireSym"></span>
                        </div>
                        <div class="col-7">
                            <input type="text" name="documentNumber" class="form-control" placeholder=""
                                [(ngModel)]="savingAgreementInterestPayment.documentNumber" id="documentNumber" #documentNumber="ngModel" required>
                            <small class="text-danger">
                                {{documentNumber.valid || !submittedForm ? ' ' : 'This field is required'}}
                            </small>
                        </div>
                    </div>
                    <div class="row form-input-row">
                        <div class="col-5 text-right"><span translate>savings.title</span><span class="requireSym"></span>
                        </div>
                        <div class="col-7">
                            <input type="text" name="savingAgreement" class="form-control" placeholder=""
                                    [(ngModel)]="savingAgreementInterestPayment.agreementNumber" id="savingAgreement" #savingAgreementRef="ngModel" readonly>
                            <small class="text-danger">
                                {{savingAgreementRef.valid || !submittedForm ? ' ' : 'This field is required'}}
                            </small>
                        </div>
                    </div>
                    <div class="row form-input-row">
                        <div class="col-5 text-right">Date<span class="requireSym"></span>
                        </div>
                        <div class="col-7">
                            <p-calendar styleClass="custom-calendar" class="w-full custom-calendar" [showIcon]="true" dataType="string"
                                    [(ngModel)]="savingAgreementInterestPayment.date" dateFormat="dd-mm-yy" [style]="{'width':'100%'}"
                                    [inputStyle]="{'width':'90%'}" name="date" required [monthNavigator]="true"
                                    [yearNavigator]="true" [yearRange]="yearRange" #dateRef="ngModel" [showOnFocus]="false"
                                    (ngModelChange)="getSavingAgreementInterestPayment()">
                            </p-calendar>
                            <small class="text-danger">
                                {{dateRef.valid || !submittedForm ? ' ' : 'This field is required'}}
                            </small>
                        </div>
                    </div>
                    <div class="row form-input-row">
                        <div class="col-5 text-right">Amount<span class="requireSym"></span>
                        </div>
                        <div class="col-7">
                            <div class="field-group">
                                <app-input-number-format type="text" style="width:100%" [allowNegative] = "false"
                                    name="calculationAmount" placeholder="" className="form-control w-full"
                                    [value]="savingAgreementInterestPayment.interestAmount" [readonly]="true">
                                </app-input-number-format>
                                <span class="base-currency-box">{{selectedCurrency}}</span>
                            </div>
                            <span [innerHTML]="'&nbsp;'"></span>
                        </div>
                    </div> 
                    <div class="row form-input-row">
                        <div class="col-5 text-right">Tax Amount<span class="requireSym"></span>
                        </div>
                        <div class="col-7">
                            <div class="field-group">
                                <app-input-number-format type="text" style="width:100%" [allowNegative] = "false"
                                    name="calculationAmount" placeholder="" className="form-control w-full"
                                    [value]="savingAgreementInterestPayment.taxAmount" [readonly]="true">
                                    <!-- (onCommitChangeValue)="onTaxAmountChange($event)"> -->
                                </app-input-number-format>
                                <span class="base-currency-box">{{selectedCurrency}}</span>
                            </div>
                            <span [innerHTML]="'&nbsp;'"></span>
                        </div>
                    </div>
                    <div class="row form-input-row">
                        <div class="col-5 text-right"><span translate>common.total_amount</span>
                        </div>
                        <div class="col-7">
                            <div class="field-group">
                                <app-input-number-format type="text" style="width:100%" [allowNegative] = "false"
                                    name="calculationAmount" placeholder="" className="form-control w-full"
                                    [value]="savingAgreementInterestPayment.totalAmount" [readonly]="true">
                                </app-input-number-format>
                                <span class="base-currency-box">{{selectedCurrency}}</span>
                            </div>
                            <span [innerHTML]="'&nbsp;'"></span>
                        </div>
                    </div>           
                    <div class="row form-input-row">
                        <div class="col-5 text-right">Branch<span class="requireSym"></span>
                        </div>
                        <div class="col-7">
                            <p-dropdown [options]="branches" name="branch" id="branch"
                                    [(ngModel)]="calculationBranchId" placeholder="Select a branch "
                                    optionLabel="name" optionValue="id" #branchRef="ngModel" required class="w-full"
                                    [style]="{'width': '100%'}">
                            </p-dropdown>
                            <small class="text-danger">
                                {{branchRef.valid || !submittedForm ? ' ' : 'This field is required'}}
                            </small>
                        </div>
                    </div>
                </div>
    
                <div class="form-input-row pt-20">
                    <div class="d-flex justify-content-center">
                        <app-button id="interest-payment" buttonClass="btn-primary"
                                    buttonType="button" (clickEvent)="onSave()" [isDisabled]="savingAgreementInterestPayment.totalAmount === 0">
                            <span translate>buttons.save</span>
                        </app-button>
                        <app-button id="btn-cancel-savings" buttonClass="btn-secondary mr-0"
                                    buttonType="button" (clickEvent)="cancel()">
                            <span translate>buttons.cancel</span>
                        </app-button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</p-dialog>